import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useSite } from '../context/SiteContext';
import { trackContactEvent } from '../utils/trackingEvents';

const Team: React.FC = () => {
  const { team, whatsappUrl, imageUrl } = useSite();

  const getPhotoUrl = (member: typeof team[0]): string => {
    if (member.photo?.image_path) return imageUrl(member.photo.image_path);
    if (member.profile_photo) return imageUrl(member.profile_photo);
    return '';
  };

  return (
    <>
      {/* Hero */}
      <section className="bg-profile-2 py-5">
        <Container>
          <Row className="text-center">
            <Col>
              <h1 className="display-4 text-profile-1 fw-bold mb-3">Nossa Equipe</h1>
              <p className="lead text-profile-4">Profissionais qualificados e experientes dedicados ao seu sorriso</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Team */}
      <section className="py-5">
        <Container>
          <Row>
            {team.map(member => (
              <Col lg={6} className="mb-4" key={member.id}>
                <Card className="h-100 shadow-sm hover-card border-0">
                  <Row className="g-0">
                    <Col md={4}>
                      {getPhotoUrl(member) ? (
                        <Card.Img
                          src={getPhotoUrl(member)}
                          alt={member.user_name}
                          className="h-100 object-fit-cover"
                          style={{ minHeight: '250px', objectPosition: 'top' }}
                          onError={(e) => { e.currentTarget.style.display = 'none'; }}
                        />
                      ) : (
                        <div className="h-100 bg-profile-5 d-flex align-items-center justify-content-center" style={{ minHeight: '250px' }}>
                          <i className="fas fa-user-md fs-1 text-profile-3"></i>
                        </div>
                      )}
                    </Col>
                    <Col md={8}>
                      <Card.Body className="d-flex flex-column h-100">
                        <div>
                          <Card.Title className="text-profile-1 h4">{member.user_name}</Card.Title>
                          {member.site_description && (
                            <h6 className="text-profile-3 mb-2">{member.site_description}</h6>
                          )}
                          {member.cro_number && (
                            <p className="text-muted small mb-2">CRO/{member.cro_uf} {member.cro_number}</p>
                          )}
                          {member.experience_years && (
                            <p className="text-muted small mb-2"><i className="fas fa-briefcase me-1"></i>{member.experience_years}+ anos de experiência</p>
                          )}
                          {(member.bio) && (
                            <Card.Text className="text-profile-4 mt-2">{member.bio}</Card.Text>
                          )}
                        </div>
                        <div className="mt-auto d-flex gap-2">
                          {member.instagram_handle && (
                            <a href={`https://instagram.com/${member.instagram_handle}`} target="_blank" rel="noopener noreferrer" className="text-profile-1">
                              <i className="fab fa-instagram fs-5"></i>
                            </a>
                          )}
                          {member.user_email && (
                            <a href={`mailto:${member.user_email}`} className="text-profile-1">
                              <i className="fas fa-envelope fs-5"></i>
                            </a>
                          )}
                        </div>
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* CTA */}
      <section className="bg-profile-1 text-white py-5">
        <Container>
          <Row className="text-center">
            <Col>
              <h3 className="mb-3">Agende sua consulta com nossos especialistas</h3>
              <p className="mb-4">Entre em contato e descubra como podemos cuidar do seu sorriso</p>
              <Button
                variant="light" size="lg" className="text-profile-1 rounded-pill px-5"
                href={whatsappUrl} target="_blank" rel="noopener noreferrer"
                onClick={trackContactEvent}
              >
                <i className="fab fa-whatsapp me-2"></i>Agendar Consulta
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      <style>{`
        .hover-card { transition: transform 0.3s ease, box-shadow 0.3s ease; }
        .hover-card:hover { transform: translateY(-5px); box-shadow: 0 10px 30px rgba(20,63,63,0.2); }
      `}</style>
    </>
  );
};

export default Team;
